//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"MaxSignalId",1,0],[0,"Name",1,0]],[[["numParameterData"],"GetParameterData",{R_:{parameterData:""}},0,0],[["parameterData"],"SetParameterData",{},1,0],[["numSignalData"],"GetSignalData",{R_:{signalData:""}},0,1],[["numSignalData"],"GetSignalDataV2",{R_:{signalData:""}},0,1],[["numSignalData","signalData"],"GetSignals",{},0,0],[["signalData"],"SetSignalData",{},1,1],[["signalData"],"SetSignalDataV2",{},1,1],[["signalData"],"SetSignals",{},1,0]],[]];
SPLM.Mechatronics.SignalAdapterBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.SignalAdapterBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.SignalAdapterBuilder.ParameterData = class{
    constructor(aliasName,physicsObject,physicsPropTag,assignedFormula,formula,comment){
        this.aliasName=aliasName;this.physicsObject=physicsObject;this.physicsPropTag=physicsPropTag;this.assignedFormula=assignedFormula;this.formula=formula;this.comment=comment;}
    get Aliasname(){return this.aliasName}
    set Aliasname(val){this.aliasName = val}
    get Physicsobject(){return this.physicsObject}
    set Physicsobject(val){this.physicsObject = val}
    get Physicsproptag(){return this.physicsPropTag}
    set Physicsproptag(val){this.physicsPropTag = val}
    get Assignedformula(){return this.assignedFormula}
    set Assignedformula(val){this.assignedFormula = val}
    get Formula(){return this.formula}
    set Formula(val){this.formula = val}
    get Comment(){return this.comment}
    set Comment(val){this.comment = val}
};

SPLM.Mechatronics.SignalAdapterBuilder.SignalData = class{
    constructor(name,dataType,portType,boolValue,intValue,doubleValue,unit,signalId,editedSignal,assignedFormula,formula,comment){
        this.name=name;this.dataType=dataType;this.portType=portType;this.boolValue=boolValue;this.intValue=intValue;this.doubleValue=doubleValue;this.unit=unit;this.signalId=signalId;this.editedSignal=editedSignal;this.assignedFormula=assignedFormula;this.formula=formula;this.comment=comment;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Datatype(){return this.dataType}
    set Datatype(val){this.dataType = val}
    get Porttype(){return this.portType}
    set Porttype(val){this.portType = val}
    get Boolvalue(){return this.boolValue}
    set Boolvalue(val){this.boolValue = val}
    get Intvalue(){return this.intValue}
    set Intvalue(val){this.intValue = val}
    get Doublevalue(){return this.doubleValue}
    set Doublevalue(val){this.doubleValue = val}
    get Unit(){return this.unit}
    set Unit(val){this.unit = val}
    get Signalid(){return this.signalId}
    set Signalid(val){this.signalId = val}
    get Editedsignal(){return this.editedSignal}
    set Editedsignal(val){this.editedSignal = val}
    get Assignedformula(){return this.assignedFormula}
    set Assignedformula(val){this.assignedFormula = val}
    get Formula(){return this.formula}
    set Formula(val){this.formula = val}
    get Comment(){return this.comment}
    set Comment(val){this.comment = val}
};

SPLM.Mechatronics.SignalAdapterBuilder.SignalDataV2 = class{
    constructor(name,dataType,portType,boolValue,intValue,doubleValue,stringValue,unit,signalId,editedSignal,assignedFormula,formula,comment){
        this.name=name;this.dataType=dataType;this.portType=portType;this.boolValue=boolValue;this.intValue=intValue;this.doubleValue=doubleValue;this.stringValue=stringValue;this.unit=unit;this.signalId=signalId;this.editedSignal=editedSignal;this.assignedFormula=assignedFormula;this.formula=formula;this.comment=comment;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Datatype(){return this.dataType}
    set Datatype(val){this.dataType = val}
    get Porttype(){return this.portType}
    set Porttype(val){this.portType = val}
    get Boolvalue(){return this.boolValue}
    set Boolvalue(val){this.boolValue = val}
    get Intvalue(){return this.intValue}
    set Intvalue(val){this.intValue = val}
    get Doublevalue(){return this.doubleValue}
    set Doublevalue(val){this.doubleValue = val}
    get Stringvalue(){return this.stringValue}
    set Stringvalue(val){this.stringValue = val}
    get Unit(){return this.unit}
    set Unit(val){this.unit = val}
    get Signalid(){return this.signalId}
    set Signalid(val){this.signalId = val}
    get Editedsignal(){return this.editedSignal}
    set Editedsignal(val){this.editedSignal = val}
    get Assignedformula(){return this.assignedFormula}
    set Assignedformula(val){this.assignedFormula = val}
    get Formula(){return this.formula}
    set Formula(val){this.formula = val}
    get Comment(){return this.comment}
    set Comment(val){this.comment = val}
};

SPLM.Mechatronics.SignalAdapterBuilder.DataType = Object.freeze({
    "Bool" : "Bool", "Int" : "Int", "Double" : "Double", "String" : "String"});

SPLM.Mechatronics.SignalAdapterBuilder.DataPortType = Object.freeze({
    "Input" : "Input", "Output" : "Output"});

export default SPLM;